import React from 'react';
import cn from 'classnames';

import {IReturnStatusBarItemProps} from './IReturnStatusBarItem';

import styles from './ReturnStatusBarItem.module.scss';

const ReturnStatusBar = ({currentStep, barItemReturnStep, barItemReturnStatusLabel}: IReturnStatusBarItemProps) => {
	return (
		<div
			className={cn(styles['return-status-bar__item'], {
				[styles['return-status-bar__item--completed']]: currentStep >= barItemReturnStep,
			})}
		>
			<div className={styles['return-status-bar__step-circle']} />
			<div className={styles['return-status-bar__name']}>{barItemReturnStatusLabel}</div>
		</div>
	);
};

export default ReturnStatusBar;
